
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gongyi/playground",
      function () {
        return require("private-next-pages/gongyi/playground.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gongyi/playground"])
      });
    }
  